import React from 'react';
import classes from './PendingFormList.module.scss';
import { FormItem } from 'components/ClientForm/FormItem/FormItem';
import { FormQuestion, FormStatus } from 'types/FormsInvitation';

export interface PendingForm {
    id: number;
    name: string;
    status: FormStatus;
    questions: FormQuestion[];
}

export const firstVisibleFormId = (forms: PendingForm[]): number | null =>
    forms.find(form => form.questions.length > 0)?.id ?? null;

interface PendingFormListProps {
    title?: string;
    forms: PendingForm[];
    expandedFormId: number | null;
    answers: { [formId: number]: { [questionId: number]: string | string[] } };
    onToggle: (formId: number) => void;
    onSave: (formId: number, answers: { [questionId: number]: string | string[] }) => void;
}

export const PendingFormList: React.FC<PendingFormListProps> = props => {
    // Filter out forms with no questions
    const formsWithQuestions = props.forms.filter(form => form.questions.length > 0);

    const pendingCount = formsWithQuestions.filter(f => f.status === FormStatus.Pending).length;
    const totalFormsCount = formsWithQuestions.length;

    const getMessage = () => {
        if (totalFormsCount === 0) {
            return 'You have 0 forms to complete';
        }
        if (pendingCount === 0) {
            return `All ${totalFormsCount} ${totalFormsCount === 1 ? 'form' : 'forms'} completed!`;
        }

        return `You have ${pendingCount} ${pendingCount === 1 ? 'form' : 'forms'} to complete`;
    };

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <h2 className={classes.title}>{props.title || 'Client Questions'}</h2>
                <p className={classes.subtitle}>{getMessage()}</p>
            </div>

            <div className={classes.formList}>
                {formsWithQuestions.map(form => (
                    <FormItem
                        key={form.id}
                        formId={form.id}
                        formName={form.name}
                        status={form.status}
                        isExpanded={props.expandedFormId === form.id}
                        questions={form.questions}
                        answers={props.answers[form.id]}
                        onToggle={() => props.onToggle(form.id)}
                        onSave={props.onSave}
                    />
                ))}
            </div>
        </div>
    );
};
